// ...existing code...
import React, { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';

import '../styles/VentaForm.css';
// Carga dinámica de planes.json

const DEFAULT_API = process.env.REACT_APP_API_URL || '/api/ventas';

export default function VentaForm({ apiUrl = DEFAULT_API }) {
  const { userProfile } = useAuth();
  // Estado para los planes
  const [planesData, setPlanesData] = useState(null);
  const [form, setForm] = useState({
    agenteId: '',
    categoria: 'movil',
    tipoPedido: 'Komercial',
    numeroPedido: '',
    plan: '',
    planPrice: '',
    cedulaCliente: '',
    numeroCliente: '',
    homeNumber: '',
    customerName: '',
    esRenovacion: false
  });

  // Cargar planes.json dinámicamente
  useEffect(() => {
    const url = process.env.PUBLIC_URL + '/data/planes.json';
    console.log('Intentando cargar:', url);
    fetch(url)
      .then(res => {
        if (!res.ok) {
          console.error('Error al cargar planes.json:', res.status, res.statusText);
          return null;
        }
        return res.json();
      })
      .then(data => {
        if (!data) return;
        console.log('planesData cargado:', data);
        setPlanesData(data);
        // Inicializar el formulario con el primer plan disponible
        const grupos = Object.values(data.plansMobile);
        const allPlans = grupos.flatMap(g => g.planes);
        if (allPlans.length > 0) {
          setForm(prev => ({
            ...prev,
            plan: allPlans[0].nombre,
            planPrice: allPlans[0].precio.toString()
          }));
        }
      })
      .catch(err => {
        console.error('Error de red o parseo al cargar planes.json:', err);
      });
  }, []);
  // Arrays para múltiples IMEIs y accesorios
  const [imeis, setImeis] = useState(['']);
  const [accesorios, setAccesorios] = useState(['']);
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);

  // Auto-cargar el Agente ID cuando el usuario se autentica
  useEffect(() => {
    if (userProfile?.agenteId) {
      setForm(prev => ({
        ...prev,
        agenteId: userProfile.agenteId
      }));
    }
  }, [userProfile]);

  function update(field, value) {
    const updatedForm = { ...form, [field]: value };
    // Si se cambió el plan, buscar el precio en los datos cargados
    if (field === 'plan' && planesData) {
      const grupos = Object.values(planesData.plansMobile);
      const allPlans = grupos.flatMap(g => g.planes);
      const found = allPlans.find(p => p.nombre === value);
      updatedForm.planPrice = found ? found.precio.toString() : '';
    }
    setForm(updatedForm);
  }

    function toggleRenovacion() {
      setForm(prev => ({ ...prev, esRenovacion: !prev.esRenovacion }));
    }

  // Funciones para manejar arrays de IMEIs
  function updateImei(index, value) {
    const newImeis = [...imeis];
    newImeis[index] = value;
    setImeis(newImeis);
  }

  function addImei() {
    setImeis([...imeis, '']);
  }

  function removeImei(index) {
    if (imeis.length > 1) {
      setImeis(imeis.filter((_, i) => i !== index));
    }
  }

  // Funciones para manejar arrays de accesorios
  function updateAccesorio(index, value) {
    const newAccesorios = [...accesorios];
    newAccesorios[index] = value;
    setAccesorios(newAccesorios);
  }

  function addAccesorio() {
    setAccesorios([...accesorios, '']);
  }

  function removeAccesorio(index) {
    if (accesorios.length > 1) {
      setAccesorios(accesorios.filter((_, i) => i !== index));
    }
  }

  async function submit(e) {
    e.preventDefault();
    setLoading(true);
    setResult(null);

    // Basic validation
    if (!form.agenteId || !form.numeroPedido || !form.cedulaCliente) {
      setResult({ error: 'Complete agenteId, numeroPedido y cedulaCliente.' });
      setLoading(false);
      return;
    }

    // Filtrar IMEIs y accesorios vacíos
    const imeisFiltered = imeis.filter(i => i.trim() !== '');
    const accesoriosFiltered = accesorios.filter(a => a.trim() !== '');

    try {
      const payload = {
        ...form,
        imeis: imeisFiltered,
        accesorios: accesoriosFiltered,
        // Mantener compatibilidad con campo individual
        imei: imeisFiltered[0] || null,
        accesorioSerie: accesoriosFiltered[0] || null
      };

      const resp = await fetch(apiUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      });
      const data = await resp.json();
      if (!resp.ok) throw data;
      setResult({ success: data });
      // Reset form
      setForm({
        agenteId: userProfile?.agenteId || '',
        tipoPedido: 'Komercial',
        numeroPedido: '',
        plan: initialPlan,
        planPrice: initialPlanPrice,
        cedulaCliente: '',
        numeroCliente: '',
        homeNumber: '',
        customerName: '',
        categoria: 'movil',
        esRenovacion: false
      });
      setImeis(['']);
      setAccesorios(['']);
    } catch (err) {
      setResult({ error: err.error || JSON.stringify(err) });
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="venta-form-container">
      <form onSubmit={submit} className="form-wrapper">
        <div className="form-group">
          <label>Agente</label>
          <input 
            value={userProfile?.nombre || 'Cargando...'} 
            readOnly 
            style={{ backgroundColor: '#f0f0f0', cursor: 'not-allowed', color: '#666' }}
          />
        </div>
          <div className="form-group">
            <label>
              <input type="checkbox" checked={form.esRenovacion} onChange={toggleRenovacion} />
              &nbsp;¿Es renovación?
            </label>
          </div>

        <div className="form-section">
          <span className="form-section-title">Tipo de Venta</span>

          <div className="form-group">
            <label>Tipo Pedido</label>
            <select value={form.tipoPedido} onChange={e => update('tipoPedido', e.target.value)}>
              <option>Komercial</option>
              <option>Siebel</option>
            </select>
          </div>
        </div>

        <div className="form-group">
          <label>Número Pedido</label>
          <input value={form.numeroPedido} onChange={e => update('numeroPedido', e.target.value)} />
        </div>

        <div className="form-section">
          <span className="form-section-title">Datos del Plan</span>
          <div className="form-group">
            <label>Plan</label>
            <select value={form.plan} onChange={e => update('plan', e.target.value)} style={{ fontSize: 14, fontWeight: 500 }}>
              {planesData && Object.values(planesData.plansMobile).map(grupo => (
                <optgroup key={grupo.grupo} label={grupo.grupo}>
                  {grupo.planes.map(plan => (
                    <option key={plan.id} value={plan.nombre}>{plan.nombre}</option>
                  ))}
                </optgroup>
              ))}
            </select>
            <div style={{ fontSize: 13, color: '#007AFF', fontWeight: 600, marginTop: 6 }}>
              Precio: ₡{form.planPrice ? parseInt(form.planPrice).toLocaleString() : '0'}
            </div>
          </div>

          <div className="form-group">
            <label style={{ opacity: 0.6 }}>Precio del plan (se autocarga)</label>
            <input 
              type="text"
              value={form.planPrice ? `₡${parseInt(form.planPrice).toLocaleString()}` : ''} 
              readOnly 
              style={{ backgroundColor: '#f0f0f0', cursor: 'not-allowed' }}
              placeholder="Se autocarga al seleccionar plan"
            />
          </div>
        </div>

        {form.categoria === 'movil' && (
          <div className="form-section">
            <span className="form-section-title">📱 Terminales (IMEIs)</span>
            {imeis.map((imei, index) => (
              <div key={index} className="form-group array-field">
                <div className="array-input-row">
                  <input 
                    value={imei} 
                    onChange={e => updateImei(index, e.target.value)} 
                    placeholder={`IMEI ${index + 1}`}
                  />
                  {imeis.length > 1 && (
                    <button type="button" className="remove-btn" onClick={() => removeImei(index)}>✕</button>
                  )}
                </div>
              </div>
            ))}
            <button type="button" className="add-btn" onClick={addImei}>
              + Agregar otro terminal
            </button>

            <span className="form-section-title" style={{ marginTop: 16 }}>🎧 Accesorios</span>
            {accesorios.map((acc, index) => (
              <div key={index} className="form-group array-field">
                <div className="array-input-row">
                  <input 
                    value={acc} 
                    onChange={e => updateAccesorio(index, e.target.value)} 
                    placeholder={`Serie accesorio ${index + 1}`}
                  />
                  {accesorios.length > 1 && (
                    <button type="button" className="remove-btn" onClick={() => removeAccesorio(index)}>✕</button>
                  )}
                </div>
              </div>
            ))}
            <button type="button" className="add-btn" onClick={addAccesorio}>
              + Agregar otro accesorio
            </button>

            <div className="form-group" style={{ marginTop: 16 }}>
              <label>Teléfono Cliente (opcional)</label>
              <input value={form.numeroCliente} onChange={e => update('numeroCliente', e.target.value)} />
            </div>
          </div>
        )}

        <div className="form-group">
          <label>Cédula Cliente</label>
          <input value={form.cedulaCliente} onChange={e => update('cedulaCliente', e.target.value)} />
        </div>

        <button type="submit" disabled={loading} className="form-button">
          {loading ? 'Guardando...' : 'Guardar venta'}
        </button>

        {result && (
          <div className={`form-result ${result.error ? 'error' : 'success'}`}>
            <strong>{result.error ? '❌ Error' : '✅ Éxito'}</strong>
            <p>
              {result.error
                ? result.error
                : result.success && result.success.id
                  ? `Venta registrada: ${result.success.id}`
                  : 'Venta registrada correctamente.'}
            </p>
          </div>
        )}
      </form>
    </div>
  );
}
